Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "OfferingView2314191375",
  {"overlapping":"OfferingView2314191375--overlapping","infoContainer":"OverlappingCard830285001--infoContainer","classic":"OfferingView2314191375--classic","strip":"OfferingView2314191375--strip","grid":"OfferingView2314191375--grid","root":"OfferingView2314191375--root"},
  "",
  4,
  "OfferingView2314191375"
);

